// extracted by mini-css-extract-plugin
module.exports = {"root":"AppDetail_root__1OC-G","container":"AppDetail_container__G8IS6","main":"AppDetail_main__3-4_B","spinner":"AppDetail_spinner__3M5Ob"};